import { InputHTMLAttributes, useState } from "react";
import { Field, type FieldProps } from "formik";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import styles from "./input.module.css";

interface ComponentProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  name: string;
  placeholder?: string;
  displayInput?: string;
  disabled?: boolean;
  bg?: string;
  type?: string;
}

const CustomInput: React.FC<ComponentProps> = (props) => {
  const { name, label, placeholder, displayInput, bg, type, disabled } = props;

  const [showPassword, setShowPassword] = useState(false);

  const inputTypes = ["text", "password", "textArea"];

  const handleShowPassword = () => {
    setShowPassword((prevState) => !prevState);
  };

  return (
    <Field name={name}>
      {({ field, meta }: FieldProps) => (
        <div className={styles.container}>
          <label>{label}</label>

          {displayInput === inputTypes[0] && (
            <input
              {...field}
              className={styles.input}
              placeholder={placeholder}
              style={{ backgroundColor: bg ? bg : "#fff", width: "100%" }}
              type={type}
              disabled={disabled}
            />
          )}

          {displayInput === inputTypes[1] && (
            <div className={styles.password}>
              <input
                {...field}
                className={styles.input}
                placeholder={placeholder}
                style={{ backgroundColor: bg ? bg : "#fff", width: "100%" }}
                type={showPassword ? "text" : "password"}
              />

              <button
                className={styles.iconButton}
                onClick={handleShowPassword}
                type="button"
              >
                {showPassword ? (
                  <FaEyeSlash className={styles.icon} />
                ) : (
                  <FaEye className={styles.icon} />
                )}
              </button>
            </div>
          )}

          {displayInput === inputTypes[2] && (
            <textarea
              className={styles.input}
              {...field}
              placeholder={placeholder}
              rows={3}
              style={{ display: "block", width: "100%" }}
            />
          )}

          {meta.touched && meta.error && (
            <div className={styles.error}>{meta.error}</div>
          )}
        </div>
      )}
    </Field>
  );
};

export default CustomInput;
